import { Card, CardContent, Grid } from 'ui';
import { FunctionComponent } from 'react';
import { Typography } from 'omakase';
import { ampersandJoiner } from 'utils/arrayUtils';
import { consumer } from '@tock/coretypes';
import { useQuizResultStyles } from './quizResultStyles';
import clsx from 'clsx';

export type QuizResultGridLayoutType = 'horizontal' | 'horizontal-reversed' | 'vertical' | 'modal';

interface QuizResultProps {
  label?: string;
  layout: QuizResultGridLayoutType;
  result: consumer.IPatronQuizResult;
}

const QuizResult: FunctionComponent<QuizResultProps> = ({ label, layout, result }) => {
  const classes = useQuizResultStyles();
  const joinedName = ampersandJoiner(result.resultName || undefined);
  const isModal = layout === 'modal';
  const isHorizontal = layout === 'horizontal' || layout === 'horizontal-reversed' || isModal;
  const isReversed = layout === 'horizontal-reversed';
  const md1 = isHorizontal ? (isModal ? 3 : 4) : 12;
  const md2 = isHorizontal ? (isModal ? 9 : 8) : 12;
  const containerClassName = isReversed
    ? clsx(classes.container, classes.reversed)
    : classes.container;
  const typographyClassName = isHorizontal
    ? classes.alignment
    : clsx(classes.alignment, classes.alignmentCenter);
  const imgClassName = isHorizontal ? classes.img : clsx(classes.img, classes.imgCenter);
  const cardContentClassName = isModal ? classes.cardContentIsModal : classes.cardContent;

  return (
    <Card elevation={0} className={classes.card}>
      <CardContent className={cardContentClassName}>
        <Grid container spacing={2} className={containerClassName}>
          <Grid item className={classes.item} xs={12} sm={3} md={md1}>
            {result.resultImage && (
              <div>
                <img className={imgClassName} src={result.resultImage} alt={joinedName || 'art'} />
              </div>
            )}
          </Grid>
          <Grid item className={classes.item} xs={12} sm={9} md={md2}>
            {label && (
              <Typography variant="body02Strong" gutterBottom className={typographyClassName}>
                {label}
              </Typography>
            )}
            <Typography variant="body02Strong" className={typographyClassName} gutterBottom>
              {joinedName}
            </Typography>
            {result.resultText && (
              <Typography variant="body02" className={typographyClassName}>
                {result.resultText}
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuizResult;
